export const ALPHABETIC_REGEX = /^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/;
export const START_END_SPACE_CHECK = /^\S(.*\S)?$/gm;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const MOBILE_REGEX = /^[0-9]{10}$/;
export const MOBILE_REGEX_WITH_CODE = /^\(\d{3}\) \d{3}-\d{4}$/;;
export const E_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const EXCLUDE_COUNTRY_CODE_REGEX = /^\+1/;

// Vehicles error regex
export const INVALID_PLATE_REGEX = /no plate match/i;
export const INVALID_VIN_REGEX = /vehicle not found by vin/i;

// Define a regex pattern to match +1 followed by exactly 10 digits
export const PHONE_REGEX = /^\+1[0-9]{0,10}$/;
export const REPLACE_BY_ONE = /^\+1/;
